module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("菜品")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("点餐次数")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b290102!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/item-statics-title.vue
// module id = 828
// module chunks = 34